import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Language, Utils } from "../../../utils";
import { user as userActions } from "../../../actions";
import { Button, ErrorIcon } from "../../../components";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import makeClasses from "../styles";
import clsx from "clsx";
import { InputLabel } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { OB_TYPES } from "../../../utils/Api";

const StepOne = ({ nextStep }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const { loading, languageTexts } = useSelector((state) => ({
    loading: state.user.loading,
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  const [categories, setCategories] = useState([]);
  const [inputCi, setInputCi] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputCategory, setInputCategory] = useState(null);
  const [hasCiError, setHasCiError] = useState(false);

  const canMoveNext =
    inputCi.trim().length > 0 &&
    inputName.trim().length > 0 &&
    inputCategory !== null &&
    !hasCiError;

  useEffect(() => {
    dispatch(
      userActions.getCategories(OB_TYPES.PHYSICAL, (categories) => {
        setCategories(categories);
      }),
    );
  }, []);

  const handleCiChange = (e) => {
    const value = e.target.value;
    setInputCi(value);
    setHasCiError(!Utils.inputs.ci.regex.test(value.trim()));
  };

  const getCategoryLabel = (option) => {
    const found = categories.find((c) => c.id === option);
    return found ? found.name : "";
  };

  const handleSubmit = () => {
    const ciError = !Utils.inputs.ci.regex.test(inputCi.trim());
    if (ciError) {
      setHasCiError(true);
      return;
    }
    nextStep({
      ci: inputCi.trim(),
      name: inputName.trim(),
      categoryId: inputCategory,
    });
  };

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>
            {i18n.get("Register.StepFormTitle")}
          </div>
          <div className={classes.formText}>
            {i18n.get("Register.Step1FormText")}
          </div>
        </div>
        <form
          layout="vertical"
          onSubmit={handleSubmit}
          className={classes.form}>
          <Grid container spacing={2}>
            <Grid className={classes.inputWithErrorContainer} item xs={12}>
              <InputLabel className={classes.formSelectLabel}>
                   {i18n.get("Register.InputCILabel")}
              </InputLabel>
              <TextField
                error={hasCiError}
                placeholder={i18n.get("Register.InputCITitle")}
                className={classes.formInput}
                onChange={handleCiChange}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputCi}
                InputProps={{ classes: { input: classes.formInputTrimmed } }}
              />
              {hasCiError && (
                <div className={classes.errorMessageContainer}>
                  <ErrorIcon />
                  <div className={classes.errorMessage}>
                    {i18n.get("Register.CiErrorMessage")}
                  </div>
                </div>
              )}
            </Grid>
            <Grid item xs={12}>
              <InputLabel className={classes.formSelectLabel}>
                {i18n.get("Register.InputActivityLabel")}
              </InputLabel>
              <TextField
                placeholder={i18n.get("Register.InputActivityTitle")}
                className={classes.formInput}
                onChange={(e) => setInputName(e.target.value)}
                classes={{ root: classes.formInput }}
                variant="outlined"
                value={inputName}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel className={classes.formSelectLabel}>
                {i18n.get("Register.InputCategoryLabel")}
              </InputLabel>
              <Autocomplete
                options={categories.map((c) => c.id)}
                getOptionLabel={getCategoryLabel}
                onChange={(e, newValue) => setInputCategory(newValue)}
                classes={{ inputRoot: classes.formInputSelect }}
                value={inputCategory}
                renderInput={(params) => (
                  <TextField
                    className={classes.formInputTrimmed}
                    classes={{ root: classes.formInput }}
                    variant="outlined"
                    placeholder={i18n.get("Register.InputCategoryTitle")}
                    {...params}
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
      </div>
      <div
        className={clsx(
          classes.formSubmitContainer,
          classes.formSubmitContainerWithOneButton,
          classes.formSubmitContainerWithNoMargin,
        )}>
        <Button
          className={classes.formSubmitButton}
          onClick={handleSubmit}
          disabled={loading || !canMoveNext}>
          {i18n.get("Register.NextButton")}
        </Button>
      </div>
    </React.Fragment>
  );
};

StepOne.id = "com.Handy.Register.StepOne";
export default StepOne;
